import React from "react";
import PropTypes from "prop-types";
import FundFinder from "./shared/FundFinder";
import ContactUs from "./shared/ContactUs";

const NoFund = ({ noMedication }) => {
  return (
    <div className="f-scale-body u-richtext">
      <p className="f-h3 u-mb3" style={{ marginTop: 0 }}>
        {noMedication
          ? "Can't find the type of assistance you need? Here's some other ways we can help."
          : "We don't have a fund available."}
      </p>

      <FundFinder />
      <hr />
      <ContactUs />
    </div>
  );
};

export default NoFund;
